/**
 * @param {string} urlOrId
 * @returns {string | null}
 */
export function extractYoutubeVideoId(urlOrId) {
  if (!urlOrId || typeof urlOrId !== "string") return null;
  const raw = urlOrId.trim();
  if (/^[\w-]{11}$/.test(raw)) return raw;

  try {
    const u = new URL(raw);
    if (u.hostname.includes("youtu.be")) {
      const id = u.pathname.replace(/^\//, "").slice(0, 11);
      return /^[\w-]{11}$/.test(id) ? id : null;
    }
    const v = u.searchParams.get("v");
    if (v && /^[\w-]{11}$/.test(v)) return v;
    const embed = u.pathname.match(/\/embed\/([\w-]{11})/);
    if (embed) return embed[1];
    const shorts = u.pathname.match(/\/shorts\/([\w-]{11})/);
    if (shorts) return shorts[1];
  } catch {
    /* ignore */
  }
  return null;
}

/** @param {string} videoId */
export function youtubeThumbnailUrl(videoId) {
  return `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
}

/** @param {string} videoId */
export function youtubeWatchUrl(videoId) {
  return `https://www.youtube.com/watch?v=${videoId}`;
}

/** @param {string} videoId */
export function youtubeEmbedUrl(videoId) {
  const params = new URLSearchParams({
    playsinline: "1",
    rel: "0",
    modestbranding: "1",
    controls: "1",
    fs: "1",
    enablejsapi: "1",
  });
  // Prefer youtube.com (not nocookie) for Android WebView reliability.
  return `https://www.youtube.com/embed/${videoId}?${params.toString()}`;
}
